import React from 'react';
import { BottomNavigation, BottomNavigationAction ,makeStyles } from '@material-ui/core';
import { InsertDriveFileOutlined, MenuSharp, PeopleOutline } from '@material-ui/icons';


const useStyles = makeStyles({
  root: {
    width: '100%',
    gridArea: 'footerNav',
    height: '65px',
    backgroundColor : 'black',
    color : '#fe752f',
    borderTop : '1px solid #fe752f',
    marginTop : '10px',
    position : 'fixed',
    bottom : 0,
    '& .MuiBottomNavigationAction-label' : {
      color : '#fe752f !important',
      fontSize: '0.8rem !important',
    },
    '& .MuiBottomNavigationAction-label.Mui-selected' : {
      color : '#fe752f !important',
      fontSize: '0.8rem !important',
    },
    '& .MuiBottomNavigationAction-root.Mui-selected' : {
      color : '#fe752f !important'
    },
    '& .MuiBottomNavigationAction-root' : {
      color : '#fe752f !important'
    }

  },
  Icon : {
    backgroundColor : 'black',
    color : '#fe752f',
    fontSize: '1.5rem !important',
    '& .MuiSvgIcon-root' : {
      fontSize: '1.5rem !important',
    }
  },
  FileIcon : {
    backgroundColor : 'black',
    color : '#fe752f',
    fontSize: '1.25rem !important',
    marginBottom : '2px',
    '& .MuiSvgIcon-root' : {
      fontSize: '1.255rem !important',
      marginBottom : '3px',
    }
  }
});

export default function SimpleBottomNavigation({ handleComponent }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
        handleComponent(newValue);
      }}
      showLabels
      className={classes.root}
    >
      <BottomNavigationAction label="Files" icon={<InsertDriveFileOutlined classes={{ root : classes.FileIcon}} />} />
      <BottomNavigationAction label ="Participants" icon={<PeopleOutline classes={{ root : classes.Icon}} />} />
    </BottomNavigation>
  );
}